import React from "react";
import direction from "../../../service/direction.json";
const Maxsfone = () => {
  return (
    <div className="form-group row col-md-12 text-justify">
      <div className="col-md-8">
        <div style={{ width: "18rem;", fontSize: "20px" }}>
          <div className="card-body">
            <h5 className="card-title text-bold" style={{ fontSize: "30px" }}>
              چرا مکسفون؟
            </h5>
            <p className="card-text">
              مکسفون = خدمات تلفن ابری سایه بان
              <br />
              اگر یک سرچ ساده در اینترنت بزنید مشاهده میکنید که شرکتها و سایتهای
              متعددی در زمینه تلفن ابری فعالیت میکنند ولی سایه بان برتری های
              منحصر به فردی نسبت به سایر ارائه دهنده ها دارد که قابل چشم پوشی
              نیست:
              <ol type="1">
                <li>
                  <span className="text-bold">
                    هزینه خرید خط ابری مصوب آسیاتک:
                  </span>
                  قیمت خرید خط را دقیقا قیمت مصوب خود آسیاتک محاسبه میکنیم و حتی
                  اگر آسیاتک جشنواره های تخفیفی داشته باشد عینا شامل کاربر ما
                  نیز خواهد شد.
                </li>
                <br />
                <li>
                  <span className="text-bold">
                    -تعرفه دایورت تماس ها مصوب آسیاتک:
                  </span>
                  هزینه ی تماس ها هم طبق مصوب مخابراتی خود آسیاتک محاسبه میشود.
                </li>
                <br />
                <li>
                  <span className="text-bold">امکانات هاستد بی نظیر:</span>
                  امکاناتی که ما در سرویس هاستد ارائه میکنیم (برقراری تماس
                  خروجی، منوی صوتی ivr، داخلی ها، صف تماس و ارسال فکس) منحصر به
                  فرد است و سایر ارائه دهندگان توانایی ارائه چنین امکانات کاملی
                  را ندارند.
                </li>
                <br />
                <li>
                  <span className="text-bold">
                    استفاده از امکانات هاستد با دقایق نامحدود:
                  </span>
                  برخی از ارائه دهندگان امکاناتی که روی سرویس هاستد میدهند با
                  دقایق محدود مکالمه میباشد مثلا برای 1000دقیقه است و برای
                  مکالمات بیشتر باید هزینه هاستد بیشتری پرداخت کنید. ولی در
                  سرویس هاستد مکسفون با مبلغ مشخص و ثابتی که پرداخت میکنید تمام
                  امکانات هاستد فعال میشود و در مدت زمان بسته، بصورت مکالمه
                  نامحدود استفاده میکنید.
                </li>
                <br />
                <li>
                  <span className="text-bold">
                    امکان ارائه نمایندگی فروش تلفن ابری
                  </span>
                </li>
              </ol>
            </p>
          </div>
        </div>
      </div>
      <div className="col-md-4 text-center">
        <img
          src={`${direction.ImgDesign}sazmani.png`}
          alt="سایه بان"
          style={{ width: "500px", height: "500px" }}
        />
      </div>
    </div>
  );
};

export default Maxsfone;
